// Module
var code = `<h1>Direct</h1> <h3 class="metric-meaning">What does it mean?</h3><p>Visits from favourites, address bar, instant messengers, etc.</p> `;
// Exports
module.exports = code;